"use client";
import { useState, useEffect, Suspense } from "react";
import { Carousel } from "@material-tailwind/react";
import { Scooters } from "../../lib/graphQLRequest";
import Scooter from "./Scooter";
import { SkeletonCarrusel } from "./SkeletonCarrusel";
import ArrowRight from "../svg/ArrowRight";
import ArrowsLeft from "../svg/ArrowsLeft";

export function CarruselScooters() {
  const [scooters, setScooters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [autoplay, setAutoplay] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await Scooters();
        if (data === null) {
          setError(true)
          return
        }
        if (data.edges.length >= 4) {
          const reordered = [
            data.edges[3],
            data.edges[2],
            data.edges[0],
            data.edges[1],
            ...data.edges.slice(4),
          ];

          setScooters({ ...data, edges: reordered });
        } else {
          setScooters(data);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching scooter data:", error);
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleMouseEnter = () => {
    setAutoplay(false);
  };

  const handleMouseLeave = () => {
    setAutoplay(true);
  };

  const handleTouchStart = () => {
    setAutoplay(false);
  };

  const handleTouchEnd = () => {
    setAutoplay(true);
  };

  function useIsMobile() {
    const [isMobile, setIsMobile] = useState("");

    useEffect(() => {
      const mediaQuery = window.matchMedia("(max-width: 768px)");
      const handleResize = (e) => setIsMobile(e.matches);
      mediaQuery.addListener(handleResize);
      return () => mediaQuery.removeListener(handleResize);
    }, []);

    return isMobile;
  }

  if (loading) {
    return <SkeletonCarrusel />;
  }

  if (error) {
    return <SkeletonCarrusel />;
  }

  return (
    <div
      className="carrusel h-auto w-full pt-8 relative bg-white z-10 "
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <span className="z-10 absolute ml-4 lg:ml-[100px]">Explora MINCA SCOOTERS</span>
      <Suspense fallback={<SkeletonCarrusel />}>
        <Carousel
          autoplay={autoplay}
          loop={true}
          className="carrusel-padre relative overflow-x-hidden rounded-xl"
          prevArrow={({ loop, handlePrev, firstIndex }) => {
            return (
              <button
                onClick={handlePrev}
                disabled={!loop && firstIndex}
                aria-label="Previous slide"
                className="!absolute top-2/4 left-4 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
              >
                <ArrowsLeft />
              </button>
            );
          }}
          nextArrow={({ loop, handleNext, lastIndex }) => (
            <button
              onClick={handleNext}
              disabled={!loop && lastIndex}
              aria-label="Next slide"
              className="!absolute top-2/4 right-4 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
            >
              <ArrowRight />
            </button>
          )}
        >
          {scooters.edges.map((scooter, index) => (
            <div key={index}>
              <Scooter scooter={scooter} />
            </div>
          ))}
        </Carousel>
      </Suspense>
    </div>
  );
}
